import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'
import { CHIP_SIZE, CHIP_TYPE, COLORS, Chip } from '@repo/design-system/index'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { usePersonaStore } from '../../../../../store/usePersonaStore'
import {
  getAgeName,
  getCompanyTypeName,
  getExperienceDurationName,
  getGenderName,
  getIntimacyName,
  getJobCategoryName,
  getPronunciationName,
  getRelationshipName,
  getToneName,
} from './getNames'

const PersonaCard = ({ persona, personaId = null, deletePersona = null, showDeleteBtn = true }) => {
  const { locale } = useTranslation()
  const { removePersona, jobCategories } = usePersonaStore()

  return (
    <div
      className={persona.id === personaId ? 'bg-purple-50' : 'bg-gray-50'}
      style={{
        borderColor: persona.id === personaId ? '#503CC8' : '#f5f6fb',
        borderWidth: persona.id === personaId ? 2 : 2,
        borderRadius: 16,
        width: '95%',
        margin: '0 auto', // ensures it's centered inside each slide
        padding: 24,
        textAlign: 'center',
        boxShadow: '0 0 8px rgba(0,0,0,0.05)',
        position: 'relative',
        boxSizing: 'border-box',
      }}
    >
      <div style={{}} className="flex flex-row gap-[4px]">
        <div className={`flex gap-x-4 gap-y-8 flex-wrap w-full ${showDeleteBtn && 'pr-20'}`}>
          <Chip type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.SM} customBgColor={COLORS.GRAY100}>
            <Chip.Label customTxtColor={COLORS.GRAY600}>{getCompanyTypeName(persona.companyTypeId, locale)}</Chip.Label>
          </Chip>

          <Chip type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.SM} customBgColor={COLORS.GRAY100}>
            <Chip.Label customTxtColor={COLORS.GRAY600}>
              {getJobCategoryName(jobCategories, persona.jobCategoryId, locale)}
            </Chip.Label>
          </Chip>
          <Chip type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.SM} customBgColor={COLORS.GRAY100}>
            <Chip.Label customTxtColor={COLORS.GRAY600}>
              {getExperienceDurationName(persona.experienceDurationId, locale)}
            </Chip.Label>
          </Chip>
        </div>

        {showDeleteBtn && (
          <div style={{ position: 'absolute', top: 36, right: 6, transform: 'translateY(-50%)' }}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation()
                //지울래말래.
                const y = confirm('Do you want to delete this persona?')
                if (y) {
                  deletePersona(persona.id)
                }
              }}
            >
              <DeleteIcon style={{ width: 20 }} />
            </IconButton>
          </div>
        )}
      </div>
      <div style={{ fontWeight: 'bold', fontSize: 18 }} className="flex flex-row mt-[8px]">
        {getToneName(persona.toneId, locale)} {persona.name}
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }} className="Body2-14Md text-gray-500">
        #{getRelationshipName(persona.relationshipId, locale)} #{getIntimacyName(persona.intimacyId, locale)}
        <br />#{getAgeName(persona.ageId, locale)} #{getPronunciationName(persona.pronunciationId, locale)} #
        {getGenderName(persona.genderId, locale)}
      </div>
    </div>
  )
}

export default PersonaCard
